import { alpha } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

import {
  FABRIC_DOT_POSITION,
  FABRIC_DOT_RADIUS_X_PX,
  FABRIC_DOT_RADIUS_Y_PX,
  FABRIC_DOT_TILE_HEIGHT_PX,
  FABRIC_DOT_TILE_WIDTH_PX,
  FABRIC_GRADIENT_ALPHA,
  FABRIC_GRADIENT_ANGLE,
} from './constants';

type StyleParams = {
  isM1Enabled: boolean;
};

/** Styles for the branded Sidekick panel surface. */
const useStyles = makeStyles<StyleParams>()((theme, { isM1Enabled }) => {
  const tint = (color: unknown) => alpha(String(color), FABRIC_GRADIENT_ALPHA);

  // The dot layer is opaque everywhere except one elliptical hole per
  // tile, so it hides the gradient beneath it apart from the dots. The
  // transparent run ends and the white starts on the same 100% stop,
  // which keeps the hole edge hard instead of fading white into the
  // gradient.
  const fabricDots = `radial-gradient(${FABRIC_DOT_RADIUS_X_PX}px ${FABRIC_DOT_RADIUS_Y_PX}px at ${FABRIC_DOT_RADIUS_X_PX}px ${FABRIC_DOT_RADIUS_Y_PX}px, transparent 0, transparent 100%, ${String(theme.new.color.common.white)} 100%)`;

  const fabricGradient = `linear-gradient(${FABRIC_GRADIENT_ANGLE}, ${tint(theme.new.color.brand[200])} 0%, ${tint(theme.new.color.brand[500])} 44.24%, ${tint(theme.new.color.brand[400])} 54.61%, ${tint(theme.new.color.brand[300])} 80.66%, ${tint(theme.new.color.brand[100])} 100%)`;

  return {
    panelSurface: {
      backgroundColor: theme.new.color.common.white,
      gap: isM1Enabled ? theme.new.spacing.small : 0,
      ...(isM1Enabled
        ? {
            backgroundImage: `${fabricDots}, ${fabricGradient}`,
            backgroundPosition: `${FABRIC_DOT_POSITION}, 0 0`,
            backgroundRepeat: 'repeat, no-repeat',
            backgroundSize: `${FABRIC_DOT_TILE_WIDTH_PX}px ${FABRIC_DOT_TILE_HEIGHT_PX}px, 100% 100%`,
          }
        : {}),
    },
  };
});

export default useStyles;
